// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"f2-z"};